import { render, staticRenderFns } from "./TrademarkResponsibleForm.vue?vue&type=template&id=4f1811fe&"
import script from "./TrademarkResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports